import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CollectionInspectionTypeState {

  private prCollectionInspectionType$ = new BehaviorSubject<any>(null);

  get currentTypeInspection$(): Observable<any> {
    return this.prCollectionInspectionType$.asObservable();
  }

  get currentTypeInspection(): any {
    return this.prCollectionInspectionType$.getValue();
  }

  set currentTypeInspection(pCollection: any) {
    this.prCollectionInspectionType$.next(pCollection);
  }

  changeCurrentInspectionType(pObj: any): void {
    this.currentTypeInspection = pObj;
  }
}
